import '../Styles.css';
import { jwtDecode } from "jwt-decode";
import { Middleware, MiddlewareProvider } from './Middleware';
import axios from 'axios';
import React from 'react';
import { TokenValidateExpiration } from './Token';

const token = localStorage.getItem("token");
var decode = "";
var rfc = "";

if (token) {
    decode = jwtDecode(token);
    rfc = decode.rfc;
}

function ProviderQuestionnairesSave() {
    document.getElementById("Chg").style.display = "block";
    document.getElementById("Btn").style.display = "none";

    var Cuestionario2Pregunta3Check1 = 0;

    if (document.getElementById("Cuestionario2Pregunta3Check1").checked == true) {
        Cuestionario2Pregunta3Check1 = parseInt(document.getElementById("Cuestionario2Pregunta3Check1").value);
    }

    var Cuestionario2Pregunta3Check2 = 0;

    if (document.getElementById("Cuestionario2Pregunta3Check2").checked == true) {
        Cuestionario2Pregunta3Check2 = parseInt(document.getElementById("Cuestionario2Pregunta3Check2").value);
    }

    var Cuestionario2Pregunta3Check3 = 0;

    if (document.getElementById("Cuestionario2Pregunta3Check3").checked == true) {
        Cuestionario2Pregunta3Check3 = parseInt(document.getElementById("Cuestionario2Pregunta3Check3").value);
    }

    var Cuestionario2Pregunta3Check4 = 0;

    if (document.getElementById("Cuestionario2Pregunta3Check4").checked == true) {
        Cuestionario2Pregunta3Check4 = parseInt(document.getElementById("Cuestionario2Pregunta3Check4").value);
    }

    var Cuestionario2Pregunta3Check5 = 0;

    if (document.getElementById("Cuestionario2Pregunta3Check5").checked == true) {
        Cuestionario2Pregunta3Check5 = parseInt(document.getElementById("Cuestionario2Pregunta3Check5").value);
    }

    var Cuestionario2Pregunta3Check6 = 0;

    if (document.getElementById("Cuestionario2Pregunta3Check6").checked == true) {
        Cuestionario2Pregunta3Check6 = parseInt(document.getElementById("Cuestionario2Pregunta3Check6").value);
    }
    var Cuestionario2Pregunta3Check7 = 0;

    if (document.getElementById("Cuestionario2Pregunta3Check7").checked == true) {
        Cuestionario2Pregunta3Check7 = parseInt(document.getElementById("Cuestionario2Pregunta3Check7").value);
    }

    var Cuestionario2Pregunta3Check8 = 0;

    if (document.getElementById("Cuestionario2Pregunta3Check8").checked == true) {
        Cuestionario2Pregunta3Check8 = parseInt(document.getElementById("Cuestionario2Pregunta3Check8").value);
    }

    var Cuestionario2Pregunta3Check9 = 0;

    if (document.getElementById("Cuestionario2Pregunta3Check9").checked == true) {
        Cuestionario2Pregunta3Check9 = parseInt(document.getElementById("Cuestionario2Pregunta3Check9").value);
    }

    var Cuestionario2Pregunta3Check10 = 0;

    if (document.getElementById("Cuestionario2Pregunta3Check10").checked == true) {
        Cuestionario2Pregunta3Check10 = parseInt(document.getElementById("Cuestionario2Pregunta3Check10").value);
    }

    var Cuestionario2Pregunta3Check11 = 0;

    if (document.getElementById("Cuestionario2Pregunta3Check11").checked == true) {
        Cuestionario2Pregunta3Check11 = parseInt(document.getElementById("Cuestionario2Pregunta3Check11").value);
    }

    var Cuestionario2Pregunta3Check12 = 0;

    if (document.getElementById("Cuestionario2Pregunta3Check12").checked == true) {
        Cuestionario2Pregunta3Check12 = parseInt(document.getElementById("Cuestionario2Pregunta3Check12").value);
    }

    var Cuestionario2Pregunta3Check13 = 0;

    if (document.getElementById("Cuestionario2Pregunta3Check13").checked == true) {
        Cuestionario2Pregunta3Check13 = parseInt(document.getElementById("Cuestionario2Pregunta3Check13").value);
    }

    var Cuestionario2Pregunta3Check14 = 0;

    if (document.getElementById("Cuestionario2Pregunta3Check14").checked == true) {
        Cuestionario2Pregunta3Check14 = parseInt(document.getElementById("Cuestionario2Pregunta3Check14").value);
    }

    var Cuestionario2Pregunta3Check15 = 0;

    if (document.getElementById("Cuestionario2Pregunta3Check15").checked == true) {
        Cuestionario2Pregunta3Check15 = parseInt(document.getElementById("Cuestionario2Pregunta3Check15").value);
    }

    var Cuestionario2Pregunta3Check16 = 0;

    if (document.getElementById("Cuestionario2Pregunta3Check16").checked == true) {
        Cuestionario2Pregunta3Check16 = parseInt(document.getElementById("Cuestionario2Pregunta3Check16").value);
    }

    var Cuestionario2Pregunta3Check17 = 0;

    if (document.getElementById("Cuestionario2Pregunta3Check17").checked == true) {
        Cuestionario2Pregunta3Check17 = parseInt(document.getElementById("Cuestionario2Pregunta3Check17").value);
    }

    var Cuestionario2Pregunta3Check18 = 0;

    if (document.getElementById("Cuestionario2Pregunta3Check18").checked == true) {
        Cuestionario2Pregunta3Check18 = parseInt(document.getElementById("Cuestionario2Pregunta3Check18").value);
    }

    //

    var Cuestionario2Pregunta4Check1 = 0;

    if (document.getElementById("Cuestionario2Pregunta4Check1").checked == true) {
        Cuestionario2Pregunta4Check1 = parseInt(document.getElementById("Cuestionario2Pregunta4Check1").value);
    }

    var Cuestionario2Pregunta4Check2 = 0;

    if (document.getElementById("Cuestionario2Pregunta4Check2").checked == true) {
        Cuestionario2Pregunta4Check2 = parseInt(document.getElementById("Cuestionario2Pregunta4Check2").value);
    }

    var Cuestionario2Pregunta4Check3 = 0;

    if (document.getElementById("Cuestionario2Pregunta4Check3").checked == true) {
        Cuestionario2Pregunta4Check3 = parseInt(document.getElementById("Cuestionario2Pregunta4Check3").value);
    }

    var Cuestionario2Pregunta4Check4 = 0;

    if (document.getElementById("Cuestionario2Pregunta4Check4").checked == true) {
        Cuestionario2Pregunta4Check4 = parseInt(document.getElementById("Cuestionario2Pregunta4Check4").value);
    }

    var Cuestionario2Pregunta4Check5 = 0;

    if (document.getElementById("Cuestionario2Pregunta4Check5").checked == true) {
        Cuestionario2Pregunta4Check5 = parseInt(document.getElementById("Cuestionario2Pregunta4Check5").value);
    }

    //

    var Cuestionario2Pregunta6Check1 = 0;

    if (document.getElementById("Cuestionario2Pregunta6Check1").checked == true) {
        Cuestionario2Pregunta6Check1 = parseInt(document.getElementById("Cuestionario2Pregunta6Check1").value);
    }

    var Cuestionario2Pregunta6Check2 = 0;

    if (document.getElementById("Cuestionario2Pregunta6Check2").checked == true) {
        Cuestionario2Pregunta6Check2 = parseInt(document.getElementById("Cuestionario2Pregunta6Check2").value);
    }

    var Cuestionario2Pregunta6Check3 = 0;

    if (document.getElementById("Cuestionario2Pregunta6Check3").checked == true) {
        Cuestionario2Pregunta6Check3 = parseInt(document.getElementById("Cuestionario2Pregunta6Check3").value);
    } 

    var Cuestionario2Pregunta4Check5Add = "";

    if (document.getElementById("Cuestionario2Pregunta4Check5Add").value != "") {
        Cuestionario2Pregunta4Check5Add = document.getElementById("Cuestionario2Pregunta4Check5Add").value;
    }

    var Cuestionario2Pregunta5 = "";

    if (document.getElementById("Cuestionario2Pregunta5").value != "") {
        Cuestionario2Pregunta5 = document.getElementById("Cuestionario2Pregunta5").value;
    }
    
    var Cuestionario2Pregunta6Check3Add = "";

    if (document.getElementById("Cuestionario2Pregunta6Check3Add").value != "") {
        Cuestionario2Pregunta6Check3Add = document.getElementById("Cuestionario2Pregunta6Check3Add").value;
    }

    var Cuestionario2Pregunta7 = "";

    if (document.getElementById("Cuestionario2Pregunta7").value != "") {
        Cuestionario2Pregunta7 = document.getElementById("Cuestionario2Pregunta7").value;
    }

    axios.post(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/provider/quiestionnaires/save/'+token, {
        RFC: decode.rfc,
        
        Cuestionario1Pregunta1: parseInt(document.getElementById("Cuestionario1Pregunta1").value),
        Cuestionario1Pregunta2: parseInt(document.getElementById("Cuestionario1Pregunta2").value),
        Cuestionario1Pregunta3: parseInt(document.getElementById("Cuestionario1Pregunta3").value),

        Cuestionario2Pregunta1: parseInt(document.getElementById("Cuestionario2Pregunta1").value),
        Cuestionario2Pregunta2: parseInt(document.getElementById("Cuestionario2Pregunta2").value),

        Cuestionario2Pregunta3Check1: Cuestionario2Pregunta3Check1, 
        Cuestionario2Pregunta3Check2: Cuestionario2Pregunta3Check2, 
        Cuestionario2Pregunta3Check3: Cuestionario2Pregunta3Check3, 
        Cuestionario2Pregunta3Check4: Cuestionario2Pregunta3Check4, 
        Cuestionario2Pregunta3Check5: Cuestionario2Pregunta3Check5, 
        Cuestionario2Pregunta3Check6: Cuestionario2Pregunta3Check6, 
        Cuestionario2Pregunta3Check7: Cuestionario2Pregunta3Check7, 
        Cuestionario2Pregunta3Check8: Cuestionario2Pregunta3Check8, 
        Cuestionario2Pregunta3Check9: Cuestionario2Pregunta3Check9, 
        Cuestionario2Pregunta3Check10: Cuestionario2Pregunta3Check10,
        Cuestionario2Pregunta3Check11: Cuestionario2Pregunta3Check11,
        Cuestionario2Pregunta3Check12: Cuestionario2Pregunta3Check12,
        Cuestionario2Pregunta3Check13: Cuestionario2Pregunta3Check13,
        Cuestionario2Pregunta3Check14: Cuestionario2Pregunta3Check14,
        Cuestionario2Pregunta3Check15: Cuestionario2Pregunta3Check15,
        Cuestionario2Pregunta3Check16: Cuestionario2Pregunta3Check16,
        Cuestionario2Pregunta3Check17: Cuestionario2Pregunta3Check17,
        Cuestionario2Pregunta3Check18: Cuestionario2Pregunta3Check18,

        Cuestionario2Pregunta4Check1: Cuestionario2Pregunta4Check1,   
        Cuestionario2Pregunta4Check2: Cuestionario2Pregunta4Check2,   
        Cuestionario2Pregunta4Check3: Cuestionario2Pregunta4Check3,   
        Cuestionario2Pregunta4Check4: Cuestionario2Pregunta4Check4,   
        Cuestionario2Pregunta4Check5: Cuestionario2Pregunta4Check5,   
        Cuestionario2Pregunta4Check5Add: Cuestionario2Pregunta4Check5Add,

        Cuestionario2Pregunta5: Cuestionario2Pregunta5,

        Cuestionario2Pregunta6Check1: Cuestionario2Pregunta6Check1,   
        Cuestionario2Pregunta6Check2: Cuestionario2Pregunta6Check2,   
        Cuestionario2Pregunta6Check3: Cuestionario2Pregunta6Check3,   
        Cuestionario2Pregunta6Check3Add: Cuestionario2Pregunta6Check3Add,

        Cuestionario2Pregunta7: Cuestionario2Pregunta7,
        }, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
    ).then(response => {
        window.location.href = '/proveedor-cuentas-bancarias';
    })
    .catch(error => {
        window.scrollTo(0, 0);
        document.getElementById("Chg").style.display = "none";
        document.getElementById("Btn").style.display = "inline-block";
        document.getElementById("messageError").innerHTML = error.response.data.error;
        console.log(error);
    });
}

function CheckUncheckAnswers() {
    const myCheckboxCuestionario2Pregunta4Check5 = document.getElementById('Cuestionario2Pregunta4Check5');

    const myCheckboxCuestionario2Pregunta6Check3 = document.getElementById('Cuestionario2Pregunta6Check3');

    var isCheckedCuestionario2Pregunta4Check5 = myCheckboxCuestionario2Pregunta4Check5.checked;

    var isCheckedCuestionario2Pregunta6Check3 = myCheckboxCuestionario2Pregunta6Check3.checked;

    if (isCheckedCuestionario2Pregunta4Check5) {
        document.getElementById("Cuestionario2Pregunta4Check5Add").disabled = false;
    } else {
        document.getElementById("Cuestionario2Pregunta4Check5Add").disabled = true;
        document.getElementById("Cuestionario2Pregunta4Check5Add").value = "";
    }

    if (isCheckedCuestionario2Pregunta6Check3) {
        document.getElementById("Cuestionario2Pregunta6Check3Add").disabled = false;
    } else {
        document.getElementById("Cuestionario2Pregunta6Check3Add").disabled = true;
        document.getElementById("Cuestionario2Pregunta6Check3Add").value = "";
    }
}

function ProviderQuestionnaires() {
    Middleware();
    MiddlewareProvider();

    const token = localStorage.getItem("token");
    TokenValidateExpiration(token);

    const cuestionario1Pregunta1 = [
        { codigo: "35", nombre: 'ENTRE 4,000,000 Y 100,000,000' },
        { codigo: "36", nombre: 'ENTRE 100,000,001 Y 250,000,000' },
        { codigo: "37", nombre: 'MAS DE 250,000,001' },
        { codigo: "38", nombre: 'MENOS DE 4,000,000' },
        { codigo: "39", nombre: 'NO DEFINIDO' },
    ];

    const cuestionario1Pregunta2 = [
        { codigo: "44", nombre: 'DE 0 A 10' },
        { codigo: "40", nombre: 'DE 11 A 99' },
        { codigo: "41", nombre: 'DE 100 A 249' },
        { codigo: "42", nombre: '250 O MÁS' },
        { codigo: "43", nombre: 'NO DEFINIDO' },
    ];

    const cuestionario1Pregunta3 = [
        { codigo: "45", nombre: 'Sí' },
        { codigo: "46", nombre: 'NO' },
    ];

    const cuestionario2Pregunta1 = [
        { codigo: "1", nombre: 'Microempresa (son todos aquellos negocios que tienen menos de 10 trabajadores, generan anualmente ventas hasta por 4 millones de pesos)' },
        { codigo: "2", nombre: 'Pequeña empresa (negocios que tiene entre 11 y 30 trabajadores o generan ventas anuales superiores a los 4 millones y hasta 100 millones de pesos)' },
        { codigo: "3", nombre: 'Mediana empresa (negocios dedicados que tiene desde 31 hasta 100 trabajadores, y generan anualmente ventas que van desde los 100 millones y pueden superar hasta 250 millones de pesos)' },
        { codigo: "4", nombre: 'Grande (empresas a aquellos negocios dedicados a los servicios y que tienen desde 101 hasta 251 trabajadores y tienen ventas superiores a los 250 millones de pesos)' },
    ];

    const cuestionario2Pregunta2 = [
        { codigo: "5", nombre: 'Sí' },
        { codigo: "6", nombre: 'No' },
    ];

    const bandera = [
        { estatus: true },
    ];

    const [isChecked, setIsChecked] = React.useState(true);

      const handleChange = (event) => {
        setIsChecked(event.target.checked);
      };

    const [answers, setAnswers] = React.useState([]);
    
        React.useEffect(() => {
            axios.get(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/provider/questionnaires-answers/get/' + rfc+'/'+token, {}, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            }
        )
        .then(response => {
            setAnswers(response.data);
            if (response.data == null) {
                setAnswers([]);
            }
        });
    }, []); 

    if (answers != "") 
    {
        answers.map(item => (
            item.Cuestionario == 2 && item.Pregunta == 3 && item.Respuesta == 7
            &&
            (document.getElementById("Cuestionario2Pregunta3Check1").checked = true),
            item.Cuestionario == 2 && item.Pregunta == 3 && item.Respuesta == 8
            &&
            (document.getElementById("Cuestionario2Pregunta3Check2").checked = true),
            item.Cuestionario == 2 && item.Pregunta == 3 && item.Respuesta == 9
            &&
            (document.getElementById("Cuestionario2Pregunta3Check3").checked = true),
            item.Cuestionario == 2 && item.Pregunta == 3 && item.Respuesta == 10
            &&
            (document.getElementById("Cuestionario2Pregunta3Check4").checked = true),
            item.Cuestionario == 2 && item.Pregunta == 3 && item.Respuesta == 11
            &&
            (document.getElementById("Cuestionario2Pregunta3Check5").checked = true),
            item.Cuestionario == 2 && item.Pregunta == 3 && item.Respuesta == 12
            &&
            (document.getElementById("Cuestionario2Pregunta3Check6").checked = true),
            item.Cuestionario == 2 && item.Pregunta == 3 && item.Respuesta == 13
            &&
            (document.getElementById("Cuestionario2Pregunta3Check7").checked = true),
            item.Cuestionario == 2 && item.Pregunta == 3 && item.Respuesta == 14
            &&
            (document.getElementById("Cuestionario2Pregunta3Check8").checked = true),
            item.Cuestionario == 2 && item.Pregunta == 3 && item.Respuesta == 15
            &&
            (document.getElementById("Cuestionario2Pregunta3Check9").checked = true),
            item.Cuestionario == 2 && item.Pregunta == 3 && item.Respuesta == 16
            &&
            (document.getElementById("Cuestionario2Pregunta3Check10").checked = true),
            item.Cuestionario == 2 && item.Pregunta == 3 && item.Respuesta == 17
            &&
            (document.getElementById("Cuestionario2Pregunta3Check11").checked = true),
            item.Cuestionario == 2 && item.Pregunta == 3 && item.Respuesta == 18
            &&
            (document.getElementById("Cuestionario2Pregunta3Check12").checked = true),
            item.Cuestionario == 2 && item.Pregunta == 3 && item.Respuesta == 19
            &&
            (document.getElementById("Cuestionario2Pregunta3Check13").checked = true),
            item.Cuestionario == 2 && item.Pregunta == 3 && item.Respuesta == 20
            &&
            (document.getElementById("Cuestionario2Pregunta3Check14").checked = true),
            item.Cuestionario == 2 && item.Pregunta == 3 && item.Respuesta == 21
            &&
            (document.getElementById("Cuestionario2Pregunta3Check15").checked = true),
            item.Cuestionario == 2 && item.Pregunta == 3 && item.Respuesta == 22
            &&
            (document.getElementById("Cuestionario2Pregunta3Check16").checked = true),
            item.Cuestionario == 2 && item.Pregunta == 3 && item.Respuesta == 23
            &&
            (document.getElementById("Cuestionario2Pregunta3Check17").checked = true),
            item.Cuestionario == 2 && item.Pregunta == 3 && item.Respuesta == 24
            &&
            (document.getElementById("Cuestionario2Pregunta3Check18").checked = true),
            //Cuestionario 2
            item.Cuestionario == 2 && item.Pregunta == 4 && item.Respuesta == 25
            && 
            (document.getElementById("Cuestionario2Pregunta4Check1").checked = true),
            item.Cuestionario == 2 && item.Pregunta == 4 && item.Respuesta == 26
            && 
            (document.getElementById("Cuestionario2Pregunta4Check2").checked = true),
            item.Cuestionario == 2 && item.Pregunta == 4 && item.Respuesta == 27
            && 
            (document.getElementById("Cuestionario2Pregunta4Check3").checked = true),
            item.Cuestionario == 2 && item.Pregunta == 4 && item.Respuesta == 28
            && 
            (document.getElementById("Cuestionario2Pregunta4Check4").checked = true),
            item.Cuestionario == 2 && item.Pregunta == 4 && item.Respuesta == 29 && item.TipoRespuesta == 5
            &&
            (document.getElementById("Cuestionario2Pregunta4Check5").checked = true,
            document.getElementById("Cuestionario2Pregunta4Check5Add").disabled = false),
            item.Cuestionario == 2 && item.Pregunta == 4 && item.Respuesta == 29 && item.TipoRespuesta == 5
            &&
            (document.getElementById("Cuestionario2Pregunta4Check5Add").value = item.RespuestaAdicional),
            item.Cuestionario == 2 && item.Pregunta == 5 && item.Respuesta == 30 && item.TipoRespuesta == 5
            &&
            (document.getElementById("Cuestionario2Pregunta5").value = item.RespuestaAdicional),
            item.Cuestionario == 2 && item.Pregunta == 6 && item.Respuesta == 31
            && 
            (document.getElementById("Cuestionario2Pregunta6Check1").checked = true),
            item.Cuestionario == 2 && item.Pregunta == 6 && item.Respuesta == 32
            && 
            (document.getElementById("Cuestionario2Pregunta6Check2").checked = true),
            item.Cuestionario == 2 && item.Pregunta == 6 && item.Respuesta == 33
            &&
            (document.getElementById("Cuestionario2Pregunta6Check3").checked = true,
            document.getElementById("Cuestionario2Pregunta6Check3Add").disabled = false),
            item.Cuestionario == 2 && item.Pregunta == 6 && item.Respuesta == 33 && item.RespuestaAdicional != ""
            &&
            (document.getElementById("Cuestionario2Pregunta6Check3Add").value = item.RespuestaAdicional),
            item.Cuestionario == 2 && item.Pregunta == 7 && item.Respuesta == 34 && item.TipoRespuesta == 2
            &&
            (document.getElementById("Cuestionario2Pregunta7").value = item.RespuestaAdicional)
        ))            
    }

    return (
        <div className='Container'>
            <div className='Navbar'>
                <div>
                    <h5 className='text-white'>Portal de proveedores</h5>
                </div>
            </div>
            <div className='Section'>
                <div className='Header'>
                    <div className="text-center">
                        <div className='row'>
                            <div className='col-md-6 Text-left'>
                                <label className='mt-1 Text-Gray'><b>Usuario: </b>
                                    {
                                        rfc
                                    }
                                </label>
                            </div>
                            <div className='col-md-6 Text-right'>
                                <a href='/logout'>
                                    <label>
                                        Cerrar sesión
                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fillRule="currentColor" className="bi bi-box-arrow-right m-1" viewBox="0 0 16 16">
                                            <path fillRule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z" />
                                            <path fillRule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z" />
                                        </svg>
                                    </label>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='Article'>
                    <div className="text-center">
                        <h1 className='Text-Red'>Cuestionario</h1>
                        <br></br>
                        <label className='text-gray'>
                            Completa el siguiente cuestionario teniendo como preguntas obligatorias las que aparecen con un asterísco (*), una vez contestado el cuestionario no podrá modificar sus respuestas.
                        </label>
                        <br></br>
                        <label id="messageError" className='Text-Red'></label>
                        <br></br>
                        <br></br>
                        <form action={ProviderQuestionnairesSave}>
                            <div className='row'>
                                <div className='col-lg-4'>
                                    <div className="question">
                                        <div>
                                            <label>Ventas Anuales<span>*</span></label>
                                            <br></br>
                                            <select name="Cuestionario1Pregunta1" id="Cuestionario1Pregunta1" aria-label="Default select example" className="form-select" required>
                                            {
                                                answers == ""
                                                ?
                                                <option value="">Selecciona...</option>
                                                :
                                                cuestionario1Pregunta1.map((item1) => (
                                                    answers.map((item2) => (
                                                    item2.Cuestionario == 1 && item2.Pregunta == 1 && item2.Respuesta == item1.codigo
                                                    &&
                                                    <option key={item1.codigo} value={item1.codigo}>{item1.nombre}</option>
                                                    ))
                                                ))
                                            }
                                            {
                                                answers == ""
                                                ?
                                                cuestionario1Pregunta1.map((item1) => (
                                                    <option key={item1.codigo} value={item1.codigo}>{item1.nombre}</option>
                                                ))
                                                :
                                                cuestionario1Pregunta1.map((item1) => (
                                                    answers.map((item2) => (
                                                    item2.Cuestionario == 1 && item2.Pregunta == 1 && item2.Respuesta != item1.codigo
                                                    &&
                                                    <option key={item1.codigo} value={item1.codigo}>{item1.nombre}</option>
                                                    ))
                                                ))
                                            }
                                            </select>
                                        </div>
                                        <br></br>
                                    </div>
                                </div>
                                <div className='col-lg-4'>
                                    <div className="question">
                                        <div>
                                            <label>Número colaboradores<span>*</span></label>
                                            <br></br>
                                            <select name="Cuestionario1Pregunta2" id="Cuestionario1Pregunta2" aria-label="Default select example" className="form-select" required>
                                            {
                                                answers == ""
                                                ?
                                                <option value="">Selecciona...</option>
                                                :
                                                cuestionario1Pregunta2.map((item1) => (
                                                    answers.map((item2) => (
                                                    item2.Cuestionario == 1 && item2.Pregunta == 2 && item2.Respuesta == item1.codigo
                                                    &&
                                                    <option key={item1.codigo} value={item1.codigo}>{item1.nombre}</option>
                                                    ))
                                                ))
                                            }
                                            {
                                                answers == ""
                                                ?
                                                cuestionario1Pregunta2.map((item1) => (
                                                    <option key={item1.codigo} value={item1.codigo}>{item1.nombre}</option>
                                                ))
                                                :
                                                cuestionario1Pregunta2.map((item1) => (
                                                    answers.map((item2) => (
                                                    item2.Cuestionario == 1 && item2.Pregunta == 2 && item2.Respuesta != item1.codigo
                                                    &&
                                                    <option key={item1.codigo} value={item1.codigo}>{item1.nombre}</option>
                                                    ))
                                                ))
                                            }
                                            </select>
                                            <label><span></span></label>
                                        </div>
                                        <br></br>
                                    </div>
                                </div>
                                <div className='col-lg-4'>
                                    <div className="question">
                                        <div>
                                            <label>Certificado CCMX<span>*</span></label>
                                            <br></br>
                                            <select name="Cuestionario1Pregunta3" id="Cuestionario1Pregunta3" aria-label="Default select example" className="form-select" required>
                                            {
                                                answers == ""
                                                ?
                                                <option value="">Selecciona...</option>
                                                :
                                                cuestionario1Pregunta3.map((item1) => (
                                                    answers.map((item2) => (
                                                    item2.Cuestionario == 1 && item2.Pregunta == 3 && item2.Respuesta == item1.codigo
                                                    &&
                                                    <option key={item1.codigo} value={item1.codigo}>{item1.nombre}</option>
                                                    ))
                                                ))
                                            }
                                            {
                                                answers == ""
                                                ?
                                                cuestionario1Pregunta3.map((item1) => (
                                                    <option key={item1.codigo} value={item1.codigo}>{item1.nombre}</option>
                                                ))
                                                :
                                                cuestionario1Pregunta3.map((item1) => (
                                                    answers.map((item2) => (
                                                    item2.Cuestionario == 1 && item2.Pregunta == 3 && item2.Respuesta != item1.codigo
                                                    &&
                                                    <option key={item1.codigo} value={item1.codigo}>{item1.nombre}</option>
                                                    ))
                                                ))
                                            }
                                            </select>
                                            <label><span></span></label>
                                        </div>
                                        <br></br>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-lg-6'>
                                    <div className="question">
                                        <div>
                                            <label>Selecciona el tamaño de la empresa:<span>*</span></label>
                                            <br></br>
                                            <select name="Cuestionario2Pregunta1" id="Cuestionario2Pregunta1" aria-label="Default select example" className="form-select" required>
                                            {
                                                answers == ""
                                                ?
                                                <option value="">Selecciona...</option>
                                                :
                                                cuestionario2Pregunta1.map((item1) => (
                                                    answers.map((item2) => (
                                                    item2.Cuestionario == 2 && item2.Pregunta == 1 && item2.Respuesta == item1.codigo
                                                    &&
                                                    <option key={item1.codigo} value={item1.codigo}>{item1.nombre}</option>
                                                    ))
                                                ))
                                            }
                                            {
                                                answers == ""
                                                ?
                                                cuestionario2Pregunta1.map((item1) => (
                                                    <option key={item1.codigo} value={item1.codigo}>{item1.nombre}</option>
                                                ))
                                                :
                                                cuestionario2Pregunta1.map((item1) => (
                                                    answers.map((item2) => (
                                                    item2.Cuestionario == 2 && item2.Pregunta == 1 && item2.Respuesta != item1.codigo
                                                    &&
                                                    <option key={item1.codigo} value={item1.codigo}>{item1.nombre}</option>
                                                    ))
                                                ))
                                            }
                                            </select>
                                            <label><span></span></label>
                                        </div>
                                        <br></br>
                                    </div>
                                </div>
                                <div className='col-lg-6'>
                                    <div className="question">
                                        <div>
                                            <label>¿La empresa forma parte del Pacto Mundial de las Naciones Unidas?<span>*</span></label>
                                            <br></br>
                                            <select name="Cuestionario2Pregunta2" id="Cuestionario2Pregunta2" aria-label="Default select example" className="form-select" required>
                                            {
                                                answers == ""
                                                ?
                                                <option value="">Selecciona...</option>
                                                :
                                                cuestionario2Pregunta2.map((item1) => (
                                                    answers.map((item2) => (
                                                    item2.Cuestionario == 2 && item2.Pregunta == 2 && item2.Respuesta == item1.codigo
                                                    &&
                                                    <option key={item1.codigo} value={item1.codigo}>{item1.nombre}</option>
                                                    ))
                                                ))
                                            }
                                            {
                                                answers == ""
                                                ?
                                                cuestionario2Pregunta2.map((item1) => (
                                                    <option key={item1.codigo} value={item1.codigo}>{item1.nombre}</option>
                                                ))
                                                :
                                                cuestionario2Pregunta2.map((item1) => (
                                                    answers.map((item2) => (
                                                    item2.Cuestionario == 2 && item2.Pregunta == 2 && item2.Respuesta != item1.codigo
                                                    &&
                                                    <option key={item1.codigo} value={item1.codigo}>{item1.nombre}</option>
                                                    ))
                                                ))
                                            }
                                            </select>
                                            <label><span></span></label>
                                        </div>
                                        <br></br>
                                    </div>
                                </div>
                            </div>
                            <br></br>
                            <div className='row'>
                                <div className='col-lg-6'>
                                    <div className="question text-left">
                                        <div className='Text-left'>¿Cuáles Objetivos de Desarrollo Sostenible está apoyando activamente su empresa? (marque todos los que apliquen)</div>
                                        <br></br>
                                        <div className='Text-left'>
                                            <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta3Check1" id="Cuestionario2Pregunta3Check1" value="7"></input>Fin de la pobreza</label><br></br></div>
                                            <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta3Check2" id="Cuestionario2Pregunta3Check2" value="8"></input>Hambre cero</label><br></br></div>
                                            <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta3Check3" id="Cuestionario2Pregunta3Check3" value="9"></input>Salud y bienestar</label><br></br></div>
                                            <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta3Check4" id="Cuestionario2Pregunta3Check4" value="10"></input>Educación de calidad</label><br></br></div>
                                            <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta3Check5" id="Cuestionario2Pregunta3Check5" value="11"></input>Igualdad de género</label><br></br></div>
                                            <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta3Check6" id="Cuestionario2Pregunta3Check6" value="12"></input>Agua limpia y saneamiento</label><br></br></div>
                                            <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta3Check7" id="Cuestionario2Pregunta3Check7" value="13"></input>Energía asequible y no contaminante</label><br></br></div>
                                            <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta3Check8" id="Cuestionario2Pregunta3Check8" value="14"></input>Trabajo decente y crecimiento económico</label><br></br></div>
                                            <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta3Check9" id="Cuestionario2Pregunta3Check9" value="15"></input>Industria, innovación e infraestructura</label><br></br></div>
                                            <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta3Check10" id="Cuestionario2Pregunta3Check10" value="16"></input>Reducción de las desigualdades</label><br></br></div>
                                            <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta3Check11" id="Cuestionario2Pregunta3Check11" value="17"></input>Ciudades y comunidades sostenibles</label><br></br></div>
                                            <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta3Check12" id="Cuestionario2Pregunta3Check12" value="18"></input>Producción y consumo responsables</label><br></br></div>
                                            <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta3Check13" id="Cuestionario2Pregunta3Check13" value="19"></input>Acción por el clima</label><br></br></div>
                                            <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta3Check14" id="Cuestionario2Pregunta3Check14" value="20"></input>Vida submarina</label><br></br></div>
                                            <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta3Check15" id="Cuestionario2Pregunta3Check15" value="21"></input>Vida de ecosistemas terrestres</label><br></br></div>
                                            <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta3Check16" id="Cuestionario2Pregunta3Check16" value="22"></input>Paz, justicia e instituciones sólidas</label><br></br></div>
                                            <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta3Check17" id="Cuestionario2Pregunta3Check17" value="23"></input>Alianzas para lograr los objetivos</label><br></br></div>
                                            <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta3Check18" id="Cuestionario2Pregunta3Check18" value="24"></input>Ninguno</label><br></br></div>
                                        </div>
                                        <br></br>
                                    </div>
                                </div>
                                <div className='col-lg-6'>
                                <div className="question">
                                    <div className='Text-left'>En Grupo Herdez tenemos un fuerte compromiso con la Diversidad y la Inclusión, por lo que buscamos activamente hacer negocios con representantes de las comunidades más vulnerables de nuestro entorno, por lo que le agradecemos responder las siguientes preguntas:</div>
                                    <br></br>
                                    <div className='Text-left'>Favor de indicar si la persona dueña de la empresa o con mayoría de acciones pertenece a uno o más de estos colectivos (marque todas las que apliquen):</div>
                                    <br></br>
                                    <div className='Text-left'>
                                        <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta4Check1" id="Cuestionario2Pregunta4Check1" value="25"></input>Mujeres</label><br></br></div>
                                        <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta4Check2" id="Cuestionario2Pregunta4Check2" value="26"></input>Personas con Discapacidad</label><br></br></div>
                                        <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta4Check3" id="Cuestionario2Pregunta4Check3" value="27"></input>Población LGBT+</label><br></br></div>
                                        <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta4Check4" id="Cuestionario2Pregunta4Check4" value="28"></input>Pueblos originarios o poblaciones indígenas</label><br></br></div>
                                        <div>
                                        <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta4Check5" id="Cuestionario2Pregunta4Check5" value="29" onClick={CheckUncheckAnswers}></input>Otro grupo minoritario o vulnerable en México (especifique)</label><br></br></div>
                                        <input type="text" name="Cuestionario2Pregunta4Check5Add" id="Cuestionario2Pregunta4Check5Add" pattern="[áéíóúa-zÁÉÍÓÚA-ZñÑ0-9\s]+" disabled required></input>
                                        </div>
                                    </div>
                                    <br></br>
                                </div>
                                <div className="question Text-left">
                                    <div><label>¿Qué porcentaje del total de colaboradores son mujeres?<span>*</span></label><br></br>
                                    <br></br>
                                    <input  type="text" name="Cuestionario2Pregunta5" id="Cuestionario2Pregunta5" placeholder=""className="form-control" pattern="[0-9]+" required></input><label><span></span></label></div>
                                </div>
                                <div className="question Text-left">
                                    <div></div>
                                    <div>¿Cuentan con alguna certificación sobre sustentabilidad? (seleccione los que apliquen):</div>
                                    <div></div>
                                    <div>
                                        <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta6Check1" id="Cuestionario2Pregunta6Check1" value="31"></input>Diversidad e Inclusión: NOM025, WEPs, EDGE</label><br></br></div>
                                        <div><label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta6Check2" id="Cuestionario2Pregunta6Check2" value="32"></input>Medio Ambiente: ISO 14001, 50001</label><br></br></div>
                                        <div>
                                        <div>
                                            <label><input className="form-check-input" type="checkbox" name="Cuestionario2Pregunta6Check3" id="Cuestionario2Pregunta6Check3" value="33" onClick={CheckUncheckAnswers}></input>Otros (especifique)</label><br></br>
                                            <input type="text" name="Cuestionario2Pregunta6Check3Add" id="Cuestionario2Pregunta6Check3Add" pattern="[áéíóúa-zÁÉÍÓÚA-ZñÑ0-9\s]+" disabled required></input>
                                        </div>
                                        </div>
                                    </div>
                                    <br></br>
                                </div>
                                <div className="question Text-left">
                                    <div>
                                        <label>¿Qué porcentaje de la utilidad invierte la empresa en programas de Ambiente, Sociedad y Gobierno (ASG)?<span>*</span></label>
                                        <br></br>
                                        <br></br>
                                        <input type="text" name="Cuestionario2Pregunta7" id="Cuestionario2Pregunta7" className="form-control" pattern="[0-9]+" required></input>
                                        <label><span></span></label>
                                    </div>
                                    <br></br>
                                </div>
                                </div>
                            </div>
                            <div className="text-center">
                                <i id="Chg"className="fa fa-spinner fa-spin Chg"></i>
                                <input id='Btn' type='submit' value='Continuar' className='Button-Style'></input>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ProviderQuestionnaires;